import React from "react";
import { motion } from "framer-motion";
import { FIRM } from "../lib/practiceAreas";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-[#0B0B0E] section-light"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-5 relative"
        >
          <div className="relative aspect-[4/5] overflow-hidden border border-white/5">
            <img
              src={FIRM.legalOffice}
              alt="Lawfields legal office"
              className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-black/50 to-transparent" />
          </div>
          <div className="absolute -bottom-6 -right-6 hidden md:block bg-[#E9C76A] text-[#0F0F0F] p-6 max-w-[200px]">
            <div className="font-serif text-3xl leading-none">Est.</div>
            <div className="font-serif text-3xl leading-none">2008</div>
            <div className="overline !text-[#0F0F0F]/80 mt-3">London</div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="lg:col-span-7"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-[#E9C76A]" />
            <span className="overline">About the firm</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#F5F2E8]">
            A small firm with the <span className="italic text-[#E9C76A]">undivided attention</span> of dedicated partners.
          </h2>
          <p className="mt-8 text-base md:text-lg text-white/65 font-light leading-relaxed">
            Lawfields is a small law firm run by dedicated professionals who are committed to providing
            high levels of legal advice and service to all those in need of our help. We have structured
            our business to cater to the needs of every client and aim to provide a niche and personal
            service to each and every one of you.
          </p>

          <div className="mt-12 grid sm:grid-cols-3 gap-8 border-t border-white/5 pt-10">
            <div data-testid="stat-clients">
              <div className="font-serif text-4xl text-[#E9C76A]">1,200+</div>
              <div className="overline mt-2 !text-white/40">Clients Advised</div>
            </div>
            <div data-testid="stat-areas">
              <div className="font-serif text-4xl text-[#E9C76A]">5</div>
              <div className="overline mt-2 !text-white/40">Practice Areas</div>
            </div>
            <div data-testid="stat-walkin">
              <div className="font-serif text-4xl text-[#E9C76A]">Free</div>
              <div className="overline mt-2 !text-white/40">Walk-In Advice</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
